export enum LockType {
    EMPTY = 'EMPTY',
    SINGLE = 'SINGLE',
    COUPLE = 'COUPLE'
}
